import { Nullable } from "web/types/Utils";

export const getIriFromId = (id: Nullable<string>, iriPrefix?: string) =>
  id ? `${iriPrefix}/${id}` : null;
export const getIdFromIri = (iri: Nullable<string>, iriPrefix?: string) =>
  iri ? iri.replace(`${iriPrefix}/`, "") : null;
